import { DetailsPageSeoConstants } from 'src/utils/constants/TvShowDetailsPageConstants';

import getEpisodeReqObject from './EpisodeQueryParamsGenerator';
import { FETCH_EPSIODE_QUERY } from '../../GraphQL/Queries/DetailsPageQueries/EpisodeQuery';
import { Rail, TvShowRelatedContent } from '../../GraphQL/Queries/types';
import { graphQlRequest } from '../../GraphQL/RequestHandler';

interface EpisodeResponse {
  episodes: Rail;
}

export const getEpisodeData = async (
  seasonId: string,
  selectedIndex: number,
  header: string[],
  limit?: number,
  broadCastState?: boolean
) => {
  try {
    if (seasonId) {
      const res: EpisodeResponse = await graphQlRequest(
        FETCH_EPSIODE_QUERY,
        getEpisodeReqObject(seasonId, selectedIndex, limit, broadCastState) ||
          {},
        '',
        header
      );
      return res?.episodes;
    }
  } catch (error) {
    console.error('Episode Page Service Call Error', error);
  }
  return null;
};

export const fetchEpisodeData = async (
  tvShowData: TvShowRelatedContent,
  selectedIndex: number,
  headers: string[]
) => {
  const seasonId = tvShowData.seasons?.[0]?.id;
  const broadCastState = !!tvShowData?.extended?.broadcastState;
  if (seasonId) {
    return await getEpisodeData(
      seasonId,
      selectedIndex,
      headers,
      DetailsPageSeoConstants.EPISODE_PAGE_LIMIT,
      broadCastState
    );
  }
};
